import type { NoteTextReaders } from '#src/models/noteName.ts'

const UNTITLED = 'Untitled intervention'

/* What to call a care plan intervention on screen.
 *
 * `CarePlan.title` is the obvious answer and the wrong one on its own: real
 * interventions carry none. The care plan editor writes the intervention into
 * the rich-text `description`, which is what the care plan page renders, so a
 * title-only name comes out blank on every intervention in a chart.
 *
 * Takes its reader for the reason `noteName` does: a `description` may be
 * stored as HTML or as a serialized TipTap document, and turning either into
 * text needs a parser this package must not import. Each surface hands in the
 * pair it already keeps in step — `browserNoteText` in the portal,
 * `serverNoteText` on the server.
 *
 * Length is deliberately not capped here. How much of a long intervention fits
 * is presentation, and differs between a mention chip and a markdown heading;
 * `noteName` splits the same way. */
export function interventionName(
  intervention: { title?: string; description?: string } | undefined | null,
  read: Pick<NoteTextReaders, 'firstLine'>
): string {
  const title = intervention?.title?.trim()
  if (title) {
    return title
  }
  const description = intervention?.description
  const line = description ? read.firstLine(description) : undefined
  return line?.trim() || UNTITLED
}
